var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58903 10.2845C5.6349 10.3511 5.69628 10.4056 5.76788 10.4432C5.83947 10.4809 5.91915 10.5005 6.00003 10.5005C6.08091 10.5005 6.16059 10.4809 6.23219 10.4432C6.30378 10.4056 6.36516 10.3511 6.41103 10.2845L10.911 3.7845C10.9631 3.70953 10.9937 3.62172 10.9993 3.5306C11.005 3.43949 10.9856 3.34856 10.9433 3.2677C10.9009 3.18683 10.8372 3.11912 10.759 3.07193C10.6809 3.02473 10.5913 2.99986 10.5 3H1.50003C1.40895 3.00038 1.3197 3.02557 1.24187 3.07288C1.16404 3.12019 1.10058 3.18782 1.05831 3.2685C1.01605 3.34917 0.996572 3.43985 1.00198 3.53077C1.0074 3.62168 1.03749 3.70941 1.08903 3.7845L5.58903 10.2845Z",
    fill: "#4B3A5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.8d7cabc0b62a7671a6033f6352f539ce.svg";
export { ForwardRef as ReactComponent };